import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { addModifier, type Player } from '../../player.type';
import { StatusEffect } from '../../status-effects.type';
import { DieFace } from '../../face.type';
import { SoundType } from '../../sound';
import type { Technique } from '../../techniques.type';
import type { Die } from '../../die.type';

export class BeholderTrait extends Trait {
  static baseType = TraitType.Beholder;
  static baseTitle = "Beholder\'s Glare";
  static baseText = "Gives access to the Beholder's Glare Technique.";
  static baseIcon = 'trait';

  type = BeholderTrait.baseType;
  title = BeholderTrait.baseTitle;
  text = BeholderTrait.baseText;
  icon = BeholderTrait.baseIcon;

  getTechniques(techniques: Technique[]): Technique[] {
    return [
      {
        ingredients: [DieFace.Eye, DieFace.Brain],
        title: "Beholder's Glare",
        text: 'Apply 1 Clumsy, 1 Dopey, and 1 Distracted to target.',
        tags: ['debuff'],
        audio: SoundType.MagicChaos,
        activate: (target: Player, source: Player, dice: Array<Die>) => {
          addModifier(target, StatusEffect.Clumsy, 1);
          addModifier(target, StatusEffect.Dopey, 1);
          addModifier(target, StatusEffect.Distracted, 1);
        },
      },
    ];
  }
}

TraitRegistry.register(BeholderTrait.baseType, BeholderTrait);
